<template>
    <div>
        <CModal
            size="xl"
            :centered="true"
            color="white"
            :show.sync="isShown"
            :closeOnBackdrop="false"
            >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>{{isEdit == '1' ? 'Edit' : 'Add'}} Shift</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="closePopUp()" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div style="padding: 24px">
                    <CRow style="margin-top: 16px;" class="mb-3">
                        <CCol sm="6">
                            <label>Tanggal</label>
                            <input 
                                class="form-control" 
                                v-model.trim="$v.tanggal.$model"
                                :class="{ 'is-invalid':$v.tanggal.$error, 'is-valid': !$v.tanggal.$invalid }"
                                type="date"
                            />
                        </CCol>
                        <CCol sm="6">
                            <label>Deskripsi</label>
                            <input 
                                class="form-control" 
                                placeholder="Deskripsi"
                                v-model.trim="$v.deskripsi.$model"
                                :class="{ 'is-invalid':$v.deskripsi.$error, 'is-valid': !$v.deskripsi.$invalid }"
                            />
                        </CCol>
                    </CRow>
                    <CRow class="mt-2 mb-3">
                        <CCol sm="6">
                            <label>Jam Mulai Kerja</label>
                            <input 
                                class="form-control"
                                v-model.trim="$v.jamMulai.$model"
                                :class="{ 'is-invalid':$v.jamMulai.$error, 'is-valid': !$v.jamMulai.$invalid }"
                                type="time"
                            />
                        </CCol>
                        <CCol sm="6">
                            <label>Jam Selesai Kerja</label>
                            <input 
                                class="form-control"
                                v-model.trim="$v.jamSelesai.$model"
                                :class="{ 'is-invalid':$v.jamSelesai.$error, 'is-valid': !$v.jamSelesai.$invalid }"
                                type="time"
                            />
                        </CCol>
                    </CRow>
                    <CRow class="mt-2 mb-3">
                        <CCol sm="6">
                            <label>Jam Mulai Istirahat</label>
                            <input 
                                class="form-control"
                                v-model="istirahatMulai"
                                type="time"
                            />
                        </CCol>
                        <CCol sm="6">
                            <label>Jam Selesai Istirahat</label>
                            <input 
                                class="form-control"
                                v-model="istirahatSelesai"
                                type="time"
                            />
                        </CCol>
                    </CRow>
                    <CRow style="margin-top: 46px;">
                        <CCol sm="12">
                            <CButton @click="closePopUp()" type="button" class="btn btn-cancel mr-2">Batal</CButton>
                            <CButton @click="submitForm()" class="btn btn-edit-submit">
                                <span v-if="loading == false">Simpan</span>
                                <CSpinner v-else color="default" size="sm"/>
                            </CButton>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
    </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
export default {
    components: {
        ModelSelect
    },
    mixins: [validationMixin],
    validations: {
        tanggal: {
            required
        },
        deskripsi: {
            required
        },
        jamMulai: {
            required
        },
        jamSelesai: {
            required
        }
    },
    data() {
        return {
            loading: false,
            closeIcon: require('../../../assets/menu/icon_close.svg'),
            isShown: false,
            isEdit: '',
            ids: '',
            dataDetail: [],
            hari: '',
            tanggal: '',
            deskripsi: '',
            jamMulai: '',
            jamSelesai: '',
            istirahatMulai: '',
            istirahatSelesai: '',
            unix: 0
        }
    },
    methods: {
        closePopUp() {
            this.isEdit = '',
            this.ids = '',
            this.dataDetail = []
            this.tanggal = ''
            this.hari = ''
            this.deskripsi = ''
            this.unix = 0
            this.jamMulai = ''
            this.jamSelesai = ''
            this.istirahatMulai = ''
            this.istirahatSelesai = ''
            this.isShown = false
            this.loading = false
            this.$v.$reset()
        },
        pharsData() {
            let dt = this.dataDetail
            this.tanggal = dt.tanggal
            this.hari = dt.hari
            this.deskripsi = dt.deskripsi
            this.jamMulai = dt.kerjaMasuk
            this.jamSelesai = dt.kerjaKeluar
            this.istirahatMulai = dt.istirahatKeluar
            this.istirahatSelesai = dt.istirahatMasuk
            this.unix = dt.unix
        },
        submitForm() {
            this.$v.$touch()
            if(this.$v.$invalid) {
            } else {
                this.saveShift()
                this.loading = true
            }
        },
        saveShift() {
            const daysOfWeek = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];
            const now = new Date(this.tanggal)
            const dayOfWeek = now.getDay();
            const dayName = daysOfWeek[dayOfWeek];

            let payload = {
                hari: dayName,
                deskripsi: this.deskripsi,
                istirahatKeluar: this.istirahatMulai,
                istirahatMasuk: this.istirahatSelesai,
                kerjaKeluar: this.jamSelesai,
                kerjaMasuk: this.jamMulai,
                tanggal: this.tanggal,
                unix: this.unix
            }
            let params = {
                ids: this.ids,
                flagEdit: this.isEdit == '1' ? '1' : '0',
                data: payload
            }
            this.$emit('saveShift', params)
        },
    },
    watch: {
        isShown() {
            if(this.isShown == true) {
                if(this.isEdit == '1') {
                    this.pharsData()
                }
            }
        }
    },
    mounted() {
    },
}
</script>
<style scoped>
::v-deep .modal-header {
    border-bottom: none !important;
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
</style>